import { render, staticRenderFns } from "./CaseTransferRequest.vue?vue&type=template&id=55f8c6a7&scoped=true"
import script from "./CaseTransferRequest.vue?vue&type=script&lang=js"
export * from "./CaseTransferRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f8c6a7",
  null
  
)

export default component.exports